<template>
  <PageTemplate title="Distribuidores">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <v-row v-if="items && items.length && !loading" class="container-item">
        <v-col
          v-for="({ title, telLink, email, tel, cities }, i) in items"
          :key="i"
          cols="12"
          class="item"
        >
          <div class="pb-5">
            <span class="font-weight-bold text-h6 primary--text">
              {{ title }}</span
            >
            <div class="mt-5 d-flex flex-column">
              <div>
                <v-btn
                  color="grey lighten-3"
                  text
                  class="text-none mx-n4"
                  width="auto"
                  :href="telLink"
                  ><v-icon size="20" class="mr-2">fa-whatsapp</v-icon
                  >{{ tel }}</v-btn
                >
              </div>
              <div>
                <v-btn
                  color="grey lighten-3"
                  text
                  class="text-none mx-n4"
                  width="auto"
                  :href="`mailto:` + email"
                  ><v-icon size="20" class="mr-2">fa-envelope</v-icon
                  >{{ email }}</v-btn
                >
              </div>
            </div>
          </div>
          <div class="mt-5">
            <div class="d-flex align-center">
              <v-icon size="20" color="primary">fas fa-map-marker-alt</v-icon>
              <span class="primary--text font-weight-bold ml-2">
                Cidades atendidas:</span
              >
            </div>

            <div v-if="cities" class="mt-5 d-flex flex-wrap cities">
              <div v-for="({ title }, i) in cities" :key="i">
                <span class="cities-item white--text py-1 px-2 text-caption">{{
                  title
                }}</span>
              </div>
            </div>
          </div>
          <div class="pt-sm-13 pt-8 pb-sm-7 pb-2">
            <v-divider></v-divider>
          </div>
        </v-col>
      </v-row>
      <v-alert v-else-if="!loading" type="info" width="100%">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>
    </transition>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import { getTelLinkFromPhone } from "../utils/getTelLinkFromPhone";

const _config = {
  mod: "distributors",
};
export default {
  data: () => ({
    loading: true,
  }),
  components: { PageTemplate, LoadingWidget },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ title, link, cities, tel, email }) => ({
          title,
          tel,
          telLink: getTelLinkFromPhone(tel),
          email,
          link,
          cities: this.cities
            ? this.cities.filter((item) => {
                if (cities.includes(item.id)) {
                  return item;
                }
              })
            : null,
        })
      );
    },

    cities() {
      return this.$rest("cities").list;
    },
  },
  mounted() {
    this.$rest("cities").get();

    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.item-divider hr {
  opacity: 0.5;
}
.cities {
  gap: 15px;

  &-item {
    background-color: var(--v-primary-lighten2);
    border-radius: 50px;
    white-space: nowrap;
  }
}
</style>
